import { Route, Routes } from "react-router-dom";
import BiuroPodawczeModule from ".";

const BiuroPodawczeRoute = () => {
  return (
    <Routes>
      <Route path="/:view" element={<BiuroPodawczeModule />} />
      <Route path="/*" element={<BiuroPodawczeModule />} />
    </Routes>
  );
};

export default BiuroPodawczeRoute;
